export const vaccinationRegistryTags = {
  REGISTRY: 'REGISTRY',
  ARCHIVE: 'ARCHIVE',
  REGISTRY_RECORD: 'REGISTRY_RECORD',
  UTERUS_LIST: 'UTERUS_LIST',
};
